module.exports = __webpack_public_path__ + "static/media/Round2.6fb865b6.png";